var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBankCard2LineFinance = function SvgBankCard2LineFinance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 2.5h15a.833.833 0 0 1 .833.833v13.334a.833.833 0 0 1-.834.833h-15a.833.833 0 0 1-.833-.833V3.333a.833.833 0 0 1 .833-.833ZM16.665 10H3.333v5.833h13.333V10Zm0-3.333v-2.5H3.333v2.5h13.333Z",
    fill: "#999FB4"
  })));
};
export default SvgBankCard2LineFinance;